import BaoCaoDinhKy from './BaoCaoDinhKy.jsx';

export default BaoCaoDinhKy;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-dinh-ky/index.js